export function getApplicationBaseName() {
    return "";
}

export function getApplicationApiName() {
    return "api";
}
